import { crudFor } from "./dataClient";
import { seedForums, seedForumPosts, seedForumDocuments } from "@/data/seed/forums";

export const forumsCrud = crudFor("forums", seedForums);
export const forumPostsCrud = crudFor("forum_posts", seedForumPosts);
export const forumDocsCrud = crudFor("forum_documents", seedForumDocuments);

export const forumsService = {
  async listForums() {
    const rows = await forumsCrud.list((q) => q.eq("is_published", true).order("sort_order"));
    return rows
      .filter((f) => f.is_published !== false)
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  },

  getForum(slug) {
    return forumsCrud.getBy("slug", slug);
  },

  async listPosts(forumSlug, { featuredOnly = false } = {}) {
    const rows = await forumPostsCrud.list((q) => {
      let query = q.eq("is_published", true).order("created_at", { ascending: false });
      if (forumSlug) query = query.eq("forum_slug", forumSlug);
      return query;
    });
    return rows
      .filter(
        (p) =>
          p.is_published !== false &&
          (!forumSlug || p.forum_slug === forumSlug) &&
          (!featuredOnly || p.is_featured)
      )
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  },

  async listDocuments(forumSlug) {
    const rows = await forumDocsCrud.list((q) => q.eq("forum_slug", forumSlug));
    return rows.filter((d) => d.forum_slug === forumSlug);
  },
};
